import type { ReactNode } from "react";

import Button from "@/components/button/button";
import { Icon } from "@/components/icon/icon";
import { DragHandle } from "@/features/admin/components/sortable-list";

import styles from "./draggable-card.module.css";

export default DraggableCard;
export { styles as configItemCardStyles };

interface DraggableCardProps {
  children: ReactNode;
  onRemove: () => void;
  removeLabel: string;
}

/**
 * Composes ListItem + card for sortable list items with card presentation.
 * Use inside SortableItem. Content passed as children.
 */
function DraggableCard({ children, onRemove, removeLabel }: DraggableCardProps) {
  return (
    <ListItem onRemove={onRemove} removeLabel={removeLabel}>
      <div className={styles.handleAndContent}>
        <DragHandle />
        <div className={styles.content}>
          <div className={styles.card}>{children}</div>
        </div>
      </div>
    </ListItem>
  );
}

interface ListItemProps {
  children: ReactNode;
  onRemove: () => void;
  removeLabel: string;
}

function ListItem({ children, onRemove, removeLabel }: ListItemProps) {
  return (
    <div className={styles.root}>
      <div className={styles.content}>{children}</div>
      <div className={styles.actions}>
        <Button
          type="button"
          variant="ghost"
          className={styles.removeButton}
          onClick={(event) => {
            event.stopPropagation();
            onRemove();
          }}
          onMouseDown={(event) => event.stopPropagation()}
          aria-label={removeLabel}
        >
          <Icon name="x" size={16} />
        </Button>
      </div>
    </div>
  );
}
